<template>
  <div class="tour-list">
    <van-collapse v-model="activeNames" :border="false">
      <van-collapse-item v-for="(item,index) in listData" :key="index" :name="index" :border="false" :is-link="false">
        <div slot="title" class="list-bd-top flex-between-box">
<!--          <van-image-->
<!--          width="1.9rem"-->
<!--          height="1.2rem"-->
<!--          fit="cover"-->
<!--          :src="item.image"-->
<!--          />-->
          <div style="width:1.9rem;height: 1.2rem">
            <shore-sightsee-swiper :bannerList="item.bannerList" :shorexIndex="index" :isShowIndication="false"></shore-sightsee-swiper>
          </div>
          <div class="top-text-box">
            <div class="title">{{item.shorexName}}</div>
            <div class="route">{{item.shorexBrief}}</div>
            <div class="duration">时长：{{item.duration}}</div>
          </div>
        </div>
        <div slot="right-icon" class="top-ico">
          <i class="arrow-ico"></i>
        </div>
        <div slot="default" class="list-bd-bottom">
          {{item.shorexDescription}}
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import ShoreSightseeSwiper from "@/components/shoreSightseeSwiper.vue";

export default {
  name: 'TourList',
  components: {ShoreSightseeSwiper},

  data () {
    return {
      activeNames: []
    }
  },

  props: {
    listData: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tour-list{
  ::v-deep .van-collapse-item__content{
    background-color: #f5f7f8;
    font-size: .18rem;
    color: @main-gray3;
    line-height: 1.8;
  }
  ::v-deep .van-hairline--top{
    &::after{
      display: none;
    }
    &::before{
      content: '';
      height: 1px;
      background-color: @main-gray5;
      display: block;
      top: 10px;
      left: 10px;
      right: 10px;
      position: absolute;
      z-index: 2;
    }
  }
  .van-collapse-item {
    position: relative;
    &::after{
      content: ' ';
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -3.05rem;
      width: 6.1rem;
      height: 1px;
      background-color: @main-gray5;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
  .top-ico{
    font-size: 18px;
    color: #1174b8;
    // display: flex;
    // align-items: flex-end;
    line-height: 20px;
    position: absolute;
    z-index: 10;
    bottom: 18px;
    right: 30px;
    &::after{
      content: '详情';
      font-size: 20px;
    }
    .arrow-ico{
      background: url(../../assets/shopping_cart_arrow.png);
      background-size: 200% 100%;
      width: 18px;
      height: 18px;
      display: inline-block;
      margin-right: 4px;
      vertical-align: middle;
      margin-top: -2px;
    }
  }
  ::v-deep .van-collapse-item__title {
    padding-bottom: 15px !important;
    .top-ico {
      bottom: 18px;
    }
  }
  ::v-deep .van-collapse-item__title--expanded{
    position: relative;
    padding-bottom: 5px !important;
    &::before{
      content: '';
      width: 1.38rem;
      height: 0.63rem;
      background-color: #1174b8;
      border-radius: 10px 0 0 0;
      position: absolute;
      bottom: 0;
      right: 0;
      display: block;
      z-index: 1;
    }
    .top-ico{
      bottom: 9px;
      &::after{
        content: '收起'
      }
      color: #ffffff;
      .arrow-ico{
        background-position: 100% 0;
        background-color: #1174b8;
      }
    }
  }
  .list-bd-bottom{
    font-size: 24px;
  }
}
</style>
